import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import './App.css'
import HomePage from './components/HomePage'
import PrivacyPage from './components/PrivacyPage'
import TermsPage from './components/TermsPage'
import Footer from './components/Footer'

function App() {
	return (
		<Router>
			<div className="App">
				<AppContent />
			</div>
		</Router>
	)
}

function AppContent() {
	const location = useLocation()

	useEffect(() => {
		// Update page title based on current route
		if (location.pathname === '/privacy') {
			document.title = 'Prywatność - KaloAI'
		} else if (location.pathname === '/terms') {
			document.title = 'Warunki świadczenia usług - KaloAI'
		} else {
			document.title = 'KaloAI - Śledź kalorie z AI'
		}
	}, [location])

	return (
		<main>
			<Routes>
				<Route path="/" element={<HomePage />} />
				<Route path="/privacy" element={<PrivacyPage />} />
				<Route path="/terms" element={<TermsPage />} />
			</Routes>
			<Footer />
		</main>
	)
}

export default App
